import type { QueryClient } from '@tanstack/react-query'
import { createRequireAuthBeforeLoad } from '@my-langguth/auth-ui'
import { getMeOptions } from '@/client/@tanstack/react-query.gen'

export const requireChecklistenAuth = createRequireAuthBeforeLoad({
  loginPath: '/login',
  getSessionQueryOptions: () =>
    ({ ...getMeOptions() }) as Parameters<QueryClient['ensureQueryData']>[0],
})
